import React from "react";
import styles from "../../styles/components/uploadFile.module.scss";
import axios from "axios";
import Icons from "../../public/assets/svg";
import endpoints from "../../utility/endpoints";
import _get from "lodash/get";
import DropDown from "../listWithoutcheck";

export default function index(props) {

  //console.log(props,"upload props");
  const [invalidFile, setInvalidFile] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [originalFileName, setOriginalFileName] = React.useState(null);
  const [state, setState] = React.useState({ docType: "" });
  const [dropDownState, setDropdownState] = React.useState({ docType: false });

  const handleDropDown = (item) => {
    setDropdownState({
      ...dropDownState,
      [item]: !dropDownState[item],
    });
  };

  // dropdown value selected
  const gotDropDownValue = (value, dropdownParent, haveRelated) => {
    if (haveRelated != null && haveRelated.length > 0) {
      const selectedRelatedDropdown = relatedDropdowns[haveRelated];
      selectedRelatedDropdown.nowValues = relatedDropdowns[haveRelated].filter(
        (item) => item.field_title == value
      )[0].field_options;
    }
    setDropdownState({ ...dropDownState, [dropdownParent]: false });
    props.sendDocTypeToParent({ docType: value });
    setState({ ...state, [dropdownParent]: value });
  };

  const handleFileChange = async (e, title) => {
   //console.log(props.fileType)
    if (props.type == "demand") {
      //console.log("file name  ---", e.target.files[0].name);
      let fileNameExtension = e.target.files[0].name.split(".");
      fileNameExtension = fileNameExtension[fileNameExtension.length - 1];
      if (props.fileType.includes(fileNameExtension)) {
        props.uploadFile(e.target.files[0], e.target.name, title, fileNameExtension);
        setOriginalFileName(e.target.files[0].name);
        setUploading(true);
        setInvalidFile(false);
      } else {
        setInvalidFile(true);
      }
    }
    else {
      let fileNameExtension = e.target.files[0].name.split(".");

      fileNameExtension = fileNameExtension[fileNameExtension.length - 1];

      //console.log("file name extension  ---", fileNameExtension);

       let extensionFlag = false;
       
       if (typeof props.fileType == "string") {
       
         if (props.fileType.includes(fileNameExtension)) {
           extensionFlag = true;
         }
       } else {
         
         for (let i in props.fileType) {
           if (props.fileType[i].includes(fileNameExtension)) {
             extensionFlag = true;
           }
         }
       }
        if (extensionFlag == true) {
           setOriginalFileName(e.target.files[0].name);
           //console.log(e.target.files[0], "sd", e.target.name);
           props.uploadFile(
             e.target.files[0],
             e.target.name,
             title,
             e.target.files[0].name,
             fileNameExtension
           );
           if (props.type !== "framework") {
            setUploading(true);
           }
          
           setInvalidFile(false);
         } else {
           setInvalidFile(true);
         }
    }
    e.target.value = "";
  }

  React.useEffect(() => {
    //console.log(props.uploaded, "uploadedddddddd")
    if (props.uploaded == true) {
      setUploading(false);
      if (props.type == "createBot") {
        setDisabled(true);
      }
      
    } else {
      setDisabled(false);
    }
  }, [props.uploaded]);

  React.useEffect(() => {
    if (props.originalFileName != null && props.originalFileName.length > 0) {
      //console.log(props.originalFileName, "originalestFileNames");
      setOriginalFileName(props.originalFileName);
    }
  }, [props.originalFileName]);


  React.useEffect(() => {
    if (props.currentlyUploading) {
      setDisabled(true)
    }
    else {
      if (!props.uploaded) {
        setDisabled(false)
      } 
    }

  }, [props.currentlyUploading ])

  return (
    <div className={styles.wrapper}>
      {/* {props.data == false ? null : <label>Upload file</label>} */}
      <div
        className={
          disabled == true ? styles.disabledInputGroup : styles.inputGroup
        }
      >
        {props.type == "framework" ? (
          <div className={styles.dropdown}>
            <div className={styles.dropdwoncontain}>
              <div className={styles.mainhandler}>
                <p
                  className={`${styles.input}`}
                  onClick={() => {
                    handleDropDown("docType");
                  }}
                >
                  <span className={styles.left}>
                    {state["docType"] == "" ? "-doc-type-" : state["docType"]}
                  </span>
                  <span className={styles.right}>
                    <Icons name="chevron" className={styles.chevron} />
                  </span>
                </p>
                {dropDownState["docType"] == true ? (
                  <div className={styles.submenu}>
                    <DropDown
                      dropdownParent={"docType"}
                      values={_get(props,"data",[])}
                      getDropdownValue={gotDropDownValue}
                      haveRelated={null}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
        {/* {props.type == "createBot" ? null :  <label>
          <span>Upload File</span>
        </label>} */}
        <div className={styles.uploadButton}>
          <label  for={props.value}>Select from device</label>
        </div>
          <input
            type="file"
            style = {{display:"none"}}
            id={props.value}
            onChange={(e) => {
              handleFileChange(e, props.title);
            }}
             name={props.value}
             disabled={disabled}
          />
        
        <span
          className={`${styles.fileName} ${props.uploaded == true
            ? styles.uploaded
            : props.couldNotUpload == true
              ? styles.errorUploading
              : uploading == true
                ? styles.uploading
                : null
            }`}
        >
          {props.uploaded == true
            ? decodeURI(originalFileName)
            : props.couldNotUpload == true
              ? "Error while uploading"
              : uploading == true 
                ? "Uploading..."
                : " No file chosen"}
        </span>
      </div>
      <div>
       {  props.type == "createBot" && props.value !== "botDemoVideo" && !props.specialCase ? invalidFile ?  
       
        <p className={props.specialCase ?  !invalidFile ? styles.validFormatMsgSpecial : styles.invalidFormatMsgSpecial :  !invalidFile ? styles.validFormatMsg : styles.invalidFormatMsg}      style = {{    position: "absolute",
    left: "10px",
    bottom: "6px"}}>
           
      
            {/* {`Upload files in the format of ${typeof props.fileType == "string" ||
              typeof props.fileType == "object" ? props.fileType : `.mov, .avi, .mp4`}.`} */}
              Incorrect format
          </p>
          : null 
          : 
          <p className={props.specialCase ?  !invalidFile ? styles.validFormatMsgSpecial : styles.invalidFormatMsgSpecial :  !invalidFile ? styles.validFormatMsg : styles.invalidFormatMsg}>
          {`Upload files in the format of ${typeof props.fileType == "string" ||
            typeof props.fileType == "object" ? props.fileType : `.mov, .avi, .mp4`}.`}
        </p>
       }
      </div>
    </div>
  );
}
